import React from "react";
import styled from "styled-components";
import { Button, Row, Col } from "antd";
import { Metrics } from "../../theme";

const btnStyle = (props)=>`
    background-color: ${props.color || "black"};
    color: ${props.color || "black"};
    min-width:${props.size || Metrics.bulletPixelSize}px;
    min-height:${props.size || Metrics.bulletPixelSize}px;
    width: ${props.size || Metrics.bulletPixelSize}px;
    height: ${props.size || Metrics.bulletPixelSize}px;
    padding-right: 0;
    padding-left: 0;
    border-radius: ${Metrics.borderRadius}px;
    border-width: ${props.selected ? Metrics.selectedBorderWidth : 0}px;
    border-color: ${props.selected ? Metrics.selectedBorderColor : "transparent"};
`;

const ColorButton = styled(Button)`
    ${props=>btnStyle(props)}
    &:hover {${props=>btnStyle(props)}}
    &:focus {${props=>btnStyle(props)}}
`;
export const ColorSquare = styled.div`
    ${props=>btnStyle(props)}
`;
export const ColorSelection = ({colors, selectColor, 
	onSelected = (color)=>{console.log("Color: ",color);}, 
	perColumn = 7
})=>{
	const maxWidth = (perColumn * Metrics.bulletPixelSize) + (perColumn * Metrics.button.spaceMargin);
	return <Row gutter={Metrics.button.spaceMargin} type="flex" align='middle' 
		justify="space-around" style={{maxWidth}}>
		{colors.map((color,c)=>(
			<Col key={c}>
				<ColorButton height={40} key={c} selected = {color === selectColor} color={color} 
					onClick={()=>{
						onSelected(color);
					}}
				/>
			</Col>
		))}
	</Row>;
};
export default ColorButton;


// WEBPACK FOOTER //
// ./src/components/button/ColorButton.js